export {EventBroadcaster as default};

/**
* Event Broadcaster
*
* Provides broadcast/subscription event message handling
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class EventBroadcasterSingleton {
    /**
     * Stores all callback functions
     *
     * @public
     *
     * @since 7.0.0
     *
     * @type {Object}
     */
    callbacks = {};

    /**
     * Sets a custom event event state
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {String} message
     * @param {mixed}  data
     * @param {Boolean} success (optional) indicates if the operation was successful, callback wont be called if false
     *
     * @return {void}
     */
    broadcast(message, data, success = true) {
        if (success === false) {
            return;
        }

        this.callBack(message, data, success);
    }

    /**
     * Registers an on Loaded function to be called on state change
     *
     * @public
     *
     * @param {Array<Array>} events an array of arrays with event names and callback functions
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    on(events) {
        events.forEach((ev) => {
            this.setCallback(ev[0], ev[1]);
        });
    }

    /**
     * Destroys registered callbacks for the given event
     *
     * @public
     *
     * @param {Object} events an object with event names as keys and callback functions as values
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    destroy(events) {
        events.forEach((ev) => {
            this.unsetCallback(ev[0], ev[1]);
        });
    }

    /**
     * Sets a loaded callback function
     *
     * @private
     *
     * @since 7.0.0
     *
     * @param {String}   message
     * @param {Function} callable callback function
     *
     * @return {void}
     */
    setCallback(message, callback) {
        if (!this.callbacks[message]) {
            this.callbacks[message] = []
        }

        this.callbacks[message].push(callback);
    }

    /**
     * Destroys a registered callback
     *
     * @private
     *
     * @since 7.0.0
     *
     * @param {String}   message
     * @param {Function} callable callback function
     *
     * @return {void}
     */
    unsetCallback(message, callback) {
        if (!this.callbacks[message]) {
            return;
        }

        let index = this.callbacks[message].indexOf(callback);

        if (index > -1) {
            this.callbacks[message].splice(index, 1);
        }
    }

    /**
     * Calls all registered loaded calbacks
     *
     * @private
     *
     * @since 7.0.0
     *
     * @param {String} id   operation id
     * @param {mixed}  data
     *
     * @return {void}
     */
    callBack(message, data) {
        if (!this.callbacks[message]) {
            return;
        }

        this.callbacks[message].forEach((callback) => {
            callback(data);
        })
    }
}

const EventBroadcaster = new EventBroadcasterSingleton();